import styles from './styles.module.css'
import TechInputColumn from '../tech-input-column/TechInputColumn'
import TechInputBar from '../tech-input-bar/TechInputBar'
import WorkingDaysTable from '../working-days-table/WorkingDaysTable'
import UniqueDaySettingsTable from '../unique-day-settings-table/UniqueDaySettingsTable'
import { ITechnicianPartial } from '../../../../../../../app/entities/Technician'
import { Dispatch, SetStateAction } from 'react'
import { IWeekCalendarPartial } from '../../../../../../../app/entities/WeekCalendar'
import { ILocation } from '../../../../../../../app/entities/Location'

interface ITechnicianModalContentProps {
  technicianData: ITechnicianPartial
  setTechnicianData: Dispatch<SetStateAction<ITechnicianPartial>>
  isDefaultWorkDay: boolean
  setIsDefaultWorkDay: Dispatch<SetStateAction<boolean>>
  isDefaultLunch: boolean
  setIsDefaultLunch: Dispatch<SetStateAction<boolean>>
  refetchTechnicianData: () => void
  technicianObjectId: string | undefined
  weekCalendars: IWeekCalendarPartial[]
  setWeekCalendars: Dispatch<SetStateAction<IWeekCalendarPartial[]>>
  location: ILocation | null
  setLocation: Dispatch<SetStateAction<ILocation | null>>
}

function TechnicianModalContent({
  technicianData,
  setTechnicianData,
  isDefaultLunch,
  setIsDefaultLunch,
  isDefaultWorkDay,
  setIsDefaultWorkDay,
  refetchTechnicianData,
  technicianObjectId,
  weekCalendars,
  setWeekCalendars,
  location,
  setLocation,
}: ITechnicianModalContentProps) {
  return (
    <div className={styles.mainContainer}>
      <TechInputColumn
        technicianData={technicianData}
        setTechnicianData={setTechnicianData}
        isDefaultWorkDay={isDefaultWorkDay}
        setIsDefaultWorkDay={setIsDefaultWorkDay}
        isDefaultLunch={isDefaultLunch}
        setIsDefaultLunch={setIsDefaultLunch}
        location={location}
      />
      <div className={styles.tableContainer}>
        <TechInputBar
          technicianData={technicianData}
          setTechnicianData={setTechnicianData}
          location={location}
          setLocation={setLocation}
        />
        <WorkingDaysTable
          weekCalendars={weekCalendars}
          setWeekCalendars={setWeekCalendars}
        />
        <UniqueDaySettingsTable
          technicianData={technicianData}
          isDefaultWorkDay={isDefaultWorkDay}
          isDefaultLunch={isDefaultLunch}
          refetchTechnicianData={refetchTechnicianData}
          technicianObjectId={technicianObjectId}
        />
      </div>
    </div>
  )
}

export default TechnicianModalContent
